import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const VatNumberModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "VatNumberModalContainer" */
      './VatNumberModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
